import script from "./cookiePolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./cookiePolicy.vue?vue&type=script&setup=true&lang=js"

import "./cookiePolicy.vue?vue&type=style&index=0&id=0098d975&lang=less&scoped=true"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0098d975"]])

export default __exports__